import { STATUS } from "Reports/SavedReports/constants";

export let getReportsList = {
  success: true,
  userID: 2,
  reports: createReports(10),
};

// function that creates and array of reports with as many items as the num argument
function createReports(num = 3) {
  const numArray = Array.from({ length: num }, (_, i) => i + 1);
  return numArray.map((n) => ({
    ID: n,
    boardID: n,
    title: `Report ${n}`,
    status: getRandomBoolean() ? STATUS.ACTIVE : STATUS.ARCHIVED,
    isShared: false,
  }));
}

// function to get random boolean
function getRandomBoolean() {
  return Math.random() < 0.5;
}
